import arContent from '@/data/content-ar';
import enContent from '@/data/content-en';
import type { ContentData, ServiceContent } from '@/types/content';

type Language = 'ar' | 'en';

const contentMap: Record<Language, ContentData> = {
  ar: arContent,
  en: enContent,
};

export const getContent = (language: Language = 'ar'): ContentData => {
  return contentMap[language];
};

export const getServiceContent = (serviceId: string, language: Language = 'ar'): ServiceContent | null => {
  const content = getContent(language);
  const serviceContent = content.services[serviceId];
  
  if (!serviceContent || typeof serviceContent === 'string' || 'title' in serviceContent) {
    console.warn(`Service content not found for: ${serviceId}`);
    return null;
  }
  
  return serviceContent as ServiceContent;
};

/**
 * Get nested content value by path (e.g., 'home.hero.title' or 'common.services')
 * Supports dot notation for nested objects
 */
export const getContentByPath = (path: string, language: Language = 'ar'): string | any => {
  const content = getContent(language);
  const keys = path.split('.');
  let value: any = content;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      console.warn(`Content path not found: ${path}`);
      return '';
    }
  }
  
  return value;
};

export default getContent;
